import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_TRA_NGO_REG_001_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    //#endregion
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
    });
    //#endregion
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });
    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [
        gridRefs.current["grid1"].current.getSelectedRows() || [],
      ],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_TRA_NGO_REG_001_POP_001",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(mergedData); // 조회조건 초기값
          setColums({
            grid1: rtn.grid.grid1,
          });
          gridRefs.current["grid1"].current.selectAndFocusRow(0);
        } catch (error) {}
      };
      fetchform();
    }, [userInfo, selectedData]);

    //#region Button Event
    const onSearch = async () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_tra_ngo_reg_001_01",
            params: searchRef.current.getFormdata(),
          };

          const data: any = await fnGetDataSet(params);
          setDataSources({
            grid1: data[0] || [],
          });

          gridRefs.current["grid1"].current.resetUpdate();
        } catch (error) {}
      };
      await fetchdatasource();
    };
    //#endregion
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
        },
      }),
      [columns, dataSources]
    );
    return (
      <div style={{ position: "relative" }}>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div>
          <div style={{ height: "60vh", marginTop: "10px" }}>
            <SnGrid
              ref={gridRefs.current["grid1"]} // Grid Name
              columnConfig={grids.grid1.columns} // 컬럼 설정 전달
              rowData={grids.grid1.dataSource} // Datasource
              etcProps={{
                rowSelection: "single",
              }}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_TRA_NGO_REG_001_POP_001;
